<template>

    <div class="custom_loading loader-area" style="position: absolute; left: 0; right:0; top: 0; bottom:0; margin: auto;">
    </div>
</template>


<script>
export default {
    name: "LoaderPlayer",
}
</script>